import {createMuiTheme} from '@material-ui/core/styles';
import {colores}              from './global';

const movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const theme = createMuiTheme({
  palette: {
    secondary: {
        main: colores.naranja
      },
      primary: {
        main: colores.azul
      },
      //type: 'dark'
    },
    props: {
        MuiButton: {
          size: 'small',
        },
        MuiFilledInput: {
          margin: 'dense',
        },
        MuiFormControl: {
          margin: 'dense',
        },
        MuiFormHelperText: {
          margin: 'dense',
        },
        MuiIconButton: {
          size: 'small',
        },
        MuiInputBase: {
          margin: 'dense',
        },
        MuiInputLabel: {
          margin: 'dense',
        },
        MuiListItem: {
          dense: true,
        },
        MuiOutlinedInput: {
          margin: 'dense',
        },
        MuiFab: {
          size: 'small',
        },
        MuiTable: {
          size: 'small',
        },
        MuiTextField: {
          margin: 'dense',
        },
        MuiToolbar: {
          variant: 'dense',
        },
        MuiButtonBase: {        
          disableRipple: true, 
        },
        MuiSwitch: {
          size: 'small'
        },
        MuiCheckbox: {
          size: 'small'
        },
        MuiAutocomplete: { 
          disableListWrap: true,
          autoHighlight: true,                   
          clearText: 'Borrar',
          openText: 'Abrir',
          closeText: 'Cerrar',
          noOptionsText: 'Sin opciones',
          loadingText: 'Cargando...' 
        },
        MuiListItemIcon: {
          style: { minWidth: 30 }
        },
      },
      overrides: {
        //MuiIconButton: {
          //sizeSmall: {
            // Adjust spacing to reach minimal touch target hitbox
            //marginLeft: 4,
            //marginRight: 4, 
            //marginTop: 2,
            //padding: 1,
          //},
        //},
        MuiAccordion: {
          root: { 
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, .125)',
            '&:not(:last-child)': {
              borderBottom: 0,
            },
            '&:before': {
              display: 'none',
            },
            '&$expanded': {
              margin: 'auto',
            }
          },
        },
        MuiAccordionSummary: {
          root: { 
            maxHeight: 35,
            minHeight: 35,
            '&$expanded': { 
              minHeight: 35,
            },
          },          
          expandIcon: {            
            width: 22, 
            height: 22,
          }
        }, 
        MuiCheckbox: {
          root: {
            transform: "scale(1.2)",
            width: 26,
            height: 26,
          }
        },
        MuiButton: {
          label: { fontSize: 12 }
        },
        MuiSelect: {
          icon: { marginTop: 2, marginRight: 2 },
          select: { paddingLeft: 12 } 
        },
        MuiAutocomplete: {
          popupIndicator: { marginTop: 2 },
          clearIndicator: { marginTop: 2 },
          paper: { marginTop: 0 },
          listbox: { maxHeight: movil ? 160 : 243 }, 
          option: { minHeight: movil ? 28 : undefined }
        },
        MuiTooltip:{
          tooltip:{
            fontSize: 12
           }
         },
        MuiTableRow: { 
          root: {
              "&:first-child th": {
                color: "white"
              },      
          }
        },
        MuiTabs:{
          root: {
            color: "white",
            backgroundColor: colores.tabla.encabezado, 
            minHeight: "35px"
            ,maxHeight: "35px"
          },
          indicator:{
            backgroundColor: colores.naranja,
          },
        },
        MuiTab: {
          root: {
            backgroundColor: colores.tabla.encabezado, 
            maxHeight: 35,
            minHeight: 35, 
            //color: 'inherit'
         },
         /*selected: {
            backgroundColor: colores.tabla.encabezado,
            color:'#ffff'
         }*/
        },
        MuiDialogTitle: {
          root: {
            color: "white",
            backgroundColor: colores.tabla.encabezado,//colores.azul,
            paddingTop: "6px",
            paddingBottom: "6px",
            textAlign: "center",
          }
        },
        MuiDialogContent:{
          root:{
            paddingLeft: '18px', 
            paddingRight: '18px',
            paddingBottom: "0px", 
            paddingTop: "18px"
          }
        },
        MuiDialogActions:{
          root: {
            justifyContent: 'center', 
            marginLeft: "15px",
            marginRight: "15px"
          }
        },
        MuiTableCell: {
          body: { height: 29 },
          footer: { height: 29 }
        },
        MuiListSubheader: {
          root: {
            fontSize: 12, 
            color: colores.azul,
            backgroundColor: '#FFFFFF !important',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden', 
            cursor: "default", 
            maxHeight: "35px", 
            minHeight: "35px",
            display: "inline-block", 
            verticalAlign: "middle", 
            lineHeight: "35px", 
            width: "100%", 
          },
        },
        MuiInput: {
          input: {
            fontSize: "12px !important",
          },
        },
        MuiInputLabel: { 
          root: {                      
            "&$shrink": {            
              fontSize: 15,
              background: '#ffffff',
              padding: '0px 5px 0px 0px',      
              marginLeft: "-2px !important" 
            },
          },                        
        },
      },
      typography: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: 12,
        display4: {
          fontSize: 12,
        },
        display3: {
          fontSize: 12,
        },
        display2: {
          fontSize: 12,
        },
        display1: {
          fontSize: 12,
        },
        headline: {
          fontSize: 12,
        },
        title: {
          fontSize: 12,
        },
        subtitle1: {
          fontSize: 12, 
        },
        subtitle2: {
          fontSize: 14, 
        },
        subheading: {
          fontSize: 12,
        },
        body2: {
          fontSize: 12,
        },
        body1: {
          fontSize: 12,
        },
        caption: {
          fontSize: 12,
        },
        button: {
          fontSize: 12,
        },
        h6: {
          fontSize: 15,
        },
      },
});